module.exports = __webpack_public_path__ + "static/silver_dragon_wyrmling-b91c42169038c7f426389f9a4d021349.jpg";